import React, {useEffect, useState} from 'react';
import axios from "../../common/axios";
import ClassDetailsWeeklySummaryCard from "./ClassDetailsWeeklySummaryCard";
import {Skeleton} from "antd";
import {DoneOutlineRounded} from "@mui/icons-material";

const ClassDetailsWeeklySummary = ({ classId }) => {

    const [testAssignments, setTestAssignments] = useState([]);
    const [loading, setLoading] = useState(true);

    const filterAssignments = (assignments, mondayDate) => {
        const mondayEpoch = mondayDate.getTime();

        // Sunday of this week (end of day)
        const sunday = new Date(mondayDate);
        sunday.setDate(mondayDate.getDate() + 6);
        sunday.setHours(23, 59, 59, 999);
        const sundayEpoch = sunday.getTime();

        return assignments.filter(assignment => {
            if (assignment.pathwayAssignmentState === "OPEN") {
                const assignedDate = assignment.assignedDate;
                if (assignedDate == null) return false;

                const assignedThisWeek = assignedDate >= mondayEpoch && assignedDate <= sundayEpoch;
                return assignedThisWeek;
            }

            const endDate = assignment.endDate;
            if (endDate == null) return false;

            const endsThisWeek = endDate >= mondayEpoch && endDate <= sundayEpoch;
            return endsThisWeek;
        });
    };


    useEffect(() => {
        const now = new Date();

        const monday = new Date(now);
        monday.setDate(now.getDate() - ((now.getDay() + 6) % 7)); // Monday
        monday.setHours(0, 0, 0, 0);

        const sunday = new Date(monday);
        sunday.setDate(monday.getDate() + 6); // Sunday
        sunday.setHours(23, 59, 59, 999);

        const startDate = monday.toISOString();
        const endDate = sunday.toISOString();

        const fetchAssignments = async () => {
            try {
                const availableRes = await axios.post('/web/ui/test/searchTeacherTestsAndAssignments', {
                    classId,
                    testAssignmentState: "AVAILABLE",
                    // startDate,
                    endDate
                });
                const endedRes = await axios.post('/web/ui/test/searchTeacherTestsAndAssignments', {
                    classId,
                    testAssignmentState: "ENDED",
                    // startDate,
                    endDate
                });
                const trails = await axios.get(`/web/ui/trail/classAssignments/${classId}`);

                const merged = filterAssignments(
                    [...availableRes.data, ...endedRes.data, ...trails.data],
                    monday
                );
                setTestAssignments(merged);
            } catch (error) {
                console.error("Error fetching test assignments", error);
            } finally {
                setLoading(false);
            }
        };

        fetchAssignments();
    }, [classId]);

    return (
        <div className={'ch-class-details-weekly-summary'}>
            <p className={'ch-class-details-weekly-summary-heading'}>This week at a glance</p>
            <div className={'ch-class-details-weekly-summary-content'}>
                {(!loading && testAssignments.length > 0) && testAssignments.map((item, idx) => {
                    return(
                        <ClassDetailsWeeklySummaryCard
                            key={`cdwsc-${idx}`}
                            cardDetails={item}
                        />
                    )
                })}
                {(!loading && testAssignments.length === 0) &&
                    <div className={'ch-class-details-weekly-summary-empty'}>
                        <p style={{fontSize: 36}}> <DoneOutlineRounded aria-hidden={true} fontSize={'inherit'} /> </p>
                        <p>No assignments, tests, or plans due or created this week.</p>
                        <p>Assign activities to see them appear here.</p>
                    </div>
                }
                {loading &&
                    <>
                        <Skeleton.Node active={true} style={{ width: '100%', height: 60 }} />
                        <Skeleton.Node active={true} style={{ width: '100%', height: 60 }} />
                    </>
                }
            </div>
        </div>
    );
};

export default ClassDetailsWeeklySummary;